import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SubmitButton from '../_shared/SubmitButton';

class TipOffPricing extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            wood: this.props.tipOff.wood || 0,
            general: this.props.tipOff.general || 0,
            green_waste: this.props.tipOff.green_waste || 0,
            inert: this.props.tipOff.inert || 0,
            tipOffExtras: this.props.tipOffExtras,
            tipOffTyreTypes: this.props.tipOffTyreTypes,
        };
        console.log(this.props);
    }

    componentDidMount() {
        let extras = this.state.tipOffExtras.map((extra) => {
            extra.tip_off_price = extra.tip_off_price || extra.avg_disposal_cost;
            extra.tip_off_price = extra.tip_off_price / 100;
            return extra;
        });

        let tyres = this.state.tipOffTyreTypes.map((tyre) => {
            tyre.tip_off_price = tyre.tip_off_price || 0;
            tyre.tip_off_price = tyre.tip_off_price / 100;
            return tyre;
        });

        this.setState({
            tipOffExtras: extras,
            tipOffTyreTypes: tyres,
        });
    }

    handlePriceChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        });
    };

    handleExtraPriceChange = (e, extra, type) => {
        const value = e.target.value;
        const tipOffExtras = [...this.state[type]];

        const tipOffExtra = tipOffExtras.find((tipOffExtra) => {
            return tipOffExtra.id === extra.id;
        });

        tipOffExtra['tip_off_price'] = value;

        this.setState({
            [type]: tipOffExtras,
        });
    };

    mapInputsToFormData = () => {
        let formData = new FormData();
        const mappable = ['wood', 'green_waste', 'general', 'inert'];

        mappable.map((input) => {
            formData.append(input, this.state[input]);
        });

        formData.append('tip_off_extras', JSON.stringify(this.state.tipOffExtras));
        formData.append('tip_off_tyre_types', JSON.stringify(this.state.tipOffTyreTypes));

        return formData;
    };

    onSubmit = () => {
        if (!this.validateForm()) {
            return;
        }

        this.setState({
            loading: true,
        });

        const formData = this.mapInputsToFormData();

        axios.post(this.props.formRoute, formData).then(
            (res) => {
                this.setState({
                    loading: false,
                });
                toastr.success('Tip Off pricing saved');
            },
            (err) => {
                this.setState({
                    loading: false,
                });
                toastr.error('There was a problem, please try again');
            }
        );
    };

    validateForm = () => {
        let errors = {};

        const fields = ['inert', 'general', 'wood', 'green_waste'];

        fields.map((field) => {
            if (!this.state[field] && this.state[field] !== 0) {
                errors[field] = `Filed is required`;
            }
        });

        this.state.tipOffExtras.map((extra) => {
            if (!extra.tip_off_price && extra.tip_off_price !== 0 && extra.hasOwnProperty('tip_off_price')) {
                errors[extra.id] = 'Field is required';
            }
        });

        this.state.tipOffTyreTypes.map((tyreType) => {
            if (!tyreType.tip_off_price && tyreType.tip_off_price !== 0 && tyreType.hasOwnProperty('tip_off_price')) {
                errors[tyreType.id] = 'Field is required';
            }
        });

        this.setState({
            errors: errors,
            loading: false,
        });

        if (Object.keys(errors).length > 0) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    render() {
        return (
            <div>
                <div className="row py-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Waste type</h6>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input type="text" placeholder="Wood" className="form-control" name="name" disabled />
                        </div>
                        <div className="form-group">
                            <label htmlFor="price">Price</label>
                            <input
                                type="number"
                                className="form-control"
                                name="wood"
                                min={0}
                                step={0.01}
                                value={this.state.wood}
                                onChange={(e) => this.handlePriceChange(e)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                placeholder="General Mixed"
                                className="form-control"
                                name="name"
                                disabled
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="price">Price</label>
                            <input
                                type="number"
                                className="form-control"
                                name="general"
                                min={0}
                                step={0.01}
                                value={this.state.general}
                                onChange={this.handlePriceChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                placeholder="Green waste"
                                className="form-control"
                                name="name"
                                disabled
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="price">Price</label>
                            <input
                                type="number"
                                className="form-control"
                                name="green_waste"
                                min={0}
                                step={0.01}
                                value={this.state.green_waste}
                                onChange={this.handlePriceChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input
                                type="text"
                                placeholder="Inert waste"
                                className="form-control"
                                name="name"
                                disabled
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="price">Price</label>
                            <input
                                type="number"
                                className="form-control"
                                name="inert"
                                min={0}
                                step={0.01}
                                value={this.state.inert}
                                onChange={this.handlePriceChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="row py-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Job Extras</h6>
                    </div>
                </div>
                <div className="row">
                    {this.state.tipOffExtras.map((extra) => {
                        return (
                            <div className="col-md-6" key={extra.id}>
                                <div className="form-group">
                                    <label>Name</label>
                                    <input type="text" className="form-control" placeholder={extra.name} disabled />
                                </div>
                                <div className="form-group">
                                    <label>Price</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={extra.tip_off_price}
                                        onChange={(e) => this.handleExtraPriceChange(e, extra, 'tipOffExtras')}
                                        min={0}
                                        step={0.01}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="row py-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Tyre Extras</h6>
                    </div>
                </div>
                <div className="row">
                    {this.state.tipOffTyreTypes.map((tyreType) => {
                        return (
                            <div className="col-md-6" key={tyreType.id}>
                                <div className="form-group">
                                    <label>Name</label>
                                    <input type="text" className="form-control" placeholder={tyreType.type} disabled />
                                </div>
                                <div className="form-group">
                                    <label>Price</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={tyreType.tip_off_price}
                                        onChange={(e) => this.handleExtraPriceChange(e, tyreType, 'tipOffTyreTypes')}
                                        min={0}
                                        step={0.01}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <button
                            type="submit"
                            className="btn btn-cw-green"
                            disabled={this.state.loading === true}
                            onClick={this.onSubmit}
                        >
                            {this.state.loading && (
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            )}
                            {!this.state.loading && 'Save'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('tip-off-form')) {
    let element = document.getElementById('tip-off-form');

    ReactDOM.render(
        <TipOffPricing
            tipOff={JSON.parse(element.dataset.tip_off)}
            tipOffExtras={JSON.parse(element.dataset.tip_off_extras)}
            formRoute={element.dataset.form_route}
            tipOffTyreTypes={JSON.parse(element.dataset.tip_off_tyre_types)}
        />,
        element
    );
}

export default TipOffPricing;
